import { FunctionComponent, PropsWithChildren } from 'react';

interface SecondaryMenuHeaderProps extends PropsWithChildren {}

export const SecondaryMenuHeader: FunctionComponent<SecondaryMenuHeaderProps> = ({ children }) => {
  return <div className="flex h-[50px] border-b items-center pl-6 border-gray-200 dark:border-gray-600 font-bold">{children}</div>;
};
